import { devError } from './devLog';

export const getFilenameFromUrl = (url) => {
  try {
    return new URL(url).pathname.split('/').pop();
  } catch {
    return url.split('/').pop();
  }
};

export const triggerDownload = (url, filename) => {
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.target = '_blank';
  link.click();

  if (url.startsWith('blob:')) {
    URL.revokeObjectURL(url);
  }
};

export const downloadBlob = (blob, filename) => {
  const blobUrl = URL.createObjectURL(blob);
  triggerDownload(blobUrl, filename);
};

export const downloadExistingPdf = async (candidateName, existingPdfUrl) => {
  try {
    const response = await fetch(existingPdfUrl);
    if (!response.ok) {
      throw new Error(`Failed to fetch PDF: ${response.statusText}`);
    }

    const pdfBlob = new Blob([await response.arrayBuffer()], {
      type: 'application/pdf',
    });

    downloadBlob(pdfBlob, `${candidateName}.pdf`);
  } catch (error) {
    devError('Error downloading PDF:', error);
    const errorMessage = error.message.includes('fetch')
      ? 'Unable to fetch required documents. Please check your connection and try again.'
      : 'Download unsuccessful. Please reach out to our support team at ict@science.org.au for assistance in resolving the issue.';
    alert(errorMessage);
  }
};
